<ion-header mode="ios">
  <ion-toolbar mode="ios">
    <ion-buttons slot="start">
      <app-modal-back-button [priority]="9998" (activated)="onDismiss()"></app-modal-back-button>
    </ion-buttons>

    @if (student$ | async; as student) {
      <ion-title> Slip for {{ student.forename }} </ion-title>
    }
  </ion-toolbar>
</ion-header>
@if (vm$ | async; as vm) {
  <ion-content>
    <ion-grid class="ion-no-padding" fixed>
      @if (!vm.loadingProgress) {
        <div class="slip-container">
          @if (vm.slipInfo) {
            <div>
              <div class="section-title">Slip Details</div>
              <div class="details">
                <app-student-slip-details [model]="vm.slipDetails"> </app-student-slip-details>
              </div>
              <hr />
              <div class="section-title">Slip Response</div>
              @if (vm.consentInfo) {
                <div class="consent">
                  <app-student-slip-consent
                    [model]="vm.consentInfo"
                    (submitConsent)="onSubmitConsent($event)"
                    (reloadSlip)="onReloadSlip()">
                  </app-student-slip-consent>
                </div>
              }
              @if (vm.questionsInfo) {
                <div class="questions">
                  <app-student-slip-questions [model]="vm.questionsInfo" (edit)="onEditQuestions()" (view)="onViewQuestions()">
                  </app-student-slip-questions>
                </div>
              }
              @if (vm.paymentInfo) {
                <div class="payment">
                  <app-student-slip-payment
                    [slipInfo]="vm.slipInfo"
                    [paymentInfo]="vm.paymentInfo"
                    [paymentStatus]="vm.paymentProgress.paymentStatus"
                    [progress]="vm.paymentProgress"
                    (paymentMethodUpdated)="onPaymentMethodUpdated($event)"
                  (paymentStatusChange)="onPaymentStatus($event)"></app-student-slip-payment>
                </div>
              }
              @if (vm.itemChoicesInfo) {
                <div class="item-choices">
                  <app-student-slip-item-choices
                    [slipInfo]="vm.slipInfo"
                    [model]="vm.itemChoicesInfo"
                    [paymentStatus]="vm.paymentProgress.paymentStatus"
                    [progress]="vm.paymentProgress"
                    (paymentMethodUpdated)="onPaymentMethodUpdated($event)"
                    (paymentStatusChange)="onPaymentStatus($event)"
                    (editItemChoices)="onEditItemChoices()"
                    (viewItemChoices)="onViewItemChoices()">
                  </app-student-slip-item-choices>
                </div>
              }
            </div>
          } @else {
            <div class="unsupported-container">
              <div class="unsupportedMessageCont">
                <p>This slip contains new features.</p>
                <p>To view, please update to the latest version of the Parent Hub app.</p>
              </div>
              <div class="button-container">
                <ion-button color="secondary" (click)="onVisitAppStore()"> Visit app store </ion-button>
              </div>
            </div>
          }
        </div>
      } @else {
        <app-student-slip-loading
          [working]="vm.loadingProgress.working"
          [error]="vm.loadingProgress.error"
        (retry)="onReloadSlip()"></app-student-slip-loading>
      }
    </ion-grid>
  </ion-content>
}
